import { createFileRoute } from '@tanstack/react-router'
import { Page } from '~/components'
import { useSuspenseQuery } from '~/services'
import { Table, TableHeader, TableRow, TableCell, TableBody, Card } from '@bpinternal/ui-kit-next'
import { Icon } from '~/elements'
import { CircleSlash, Lock, LockOpen, Sparkles, TableIcon } from 'lucide-react'
import { formatDate } from '@bpinternal/shared'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/tables/')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()
  const { data: tables } = useSuspenseQuery('workspaces_/$workspaceId_/bots_/$botId_/tables/$tags/all', {
    botId,
    workspaceId,
    tags: {},
  })

  const navigate = Route.useNavigate()

  return (
    <Page title="Tables">
      <Card className="overflow-hidden">
        <Table>
          <TableHeader className="bg-gray-2">
            <TableRow className="h-11 font-medium">
              <TableCell className="w-9" />
              <TableCell>Name</TableCell>
              <TableCell>Columns</TableCell>
              <TableCell className="text-center ">Frozen</TableCell>
              <TableCell className="text-center">Computed</TableCell>
              <TableCell>Last Updated</TableCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {tables?.tables.map(({ frozen, tags, id, name, updatedAt, schema, isComputeEnabled }) => {
              const isSystem = tags?.['system'] === 'true'
              return (
                <TableRow
                  key={id}
                  className="h-11 cursor-pointer hover:bg-gray-2"
                  onClick={() =>
                    navigate({
                      to: '/workspaces/$workspaceId/bots/$botId/tables/$tableId',
                      params: { tableId: id },
                      search: { limit: 50, offset: 0 },
                    })
                  }
                >
                  <TableCell>
                    <Icon icon={TableIcon} color={isSystem ? 'gray' : 'grass'} variant="soft" />
                  </TableCell>
                  <TableCell>
                    <span>{name}</span>
                  </TableCell>
                  <TableCell>
                    <span>{Object.keys(schema.properties).length}</span>
                  </TableCell>
                  <TableCell>
                    <Icon
                      icon={frozen ? Lock : LockOpen}
                      className="mx-auto"
                      color={frozen ? 'blue' : 'gray'}
                      muted={!frozen}
                      padding
                      variant={frozen ? 'soft' : 'outline'}
                    />
                  </TableCell>
                  <TableCell>
                    <Icon
                      icon={isComputeEnabled ? Sparkles : CircleSlash}
                      className="mx-auto"
                      color={isComputeEnabled ? 'iris' : 'gray'}
                      muted={!isComputeEnabled}
                      padding
                      variant={isComputeEnabled ? 'soft' : 'outline'}
                    />
                  </TableCell>
                  <TableCell>{updatedAt && <span>{formatDate(updatedAt, { relative: true })}</span>}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Card>
    </Page>
  )
}
